// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
  box-sizing: border-box;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

.translation-buttons-container {
  margin: -20px 45px 0 0;
  display: flex;
  justify-content: flex-end;
  flex-wrap: nowrap;
}

.translation-buttons-container-main {
  margin: -20px 45px 0 0;
  display: flex;
  justify-content: flex-end;
  flex-wrap: nowrap;
  flex-direction: column;
}
.translation-buttons-container-main .button-container {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-top: 5px;
}
.translation-buttons-container-main .experimental-text {
  position: relative;
  bottom: -8px;
  right: 5px;
  display: flex;
  flex-direction: row;
  font-size: 0.7rem;
  justify-content: flex-end;
}

.translation-button {
  border-radius: 3px;
  box-shadow: 0.1rem 0.15rem 0.3rem 0 #525151;
  background-color: white;
  border: none;
  color: #0669B3;
  font-size: 0.7em;
  font-weight: 600;
  height: 22px;
  margin-left: 10px;
  transition: 0.1s ease;
  width: 80px;
}
.translation-button:hover {
  background: #63AEDE;
  color: white;
  color: black;
  font-weight: 500;
}
.translation-button:active {
  color: #D1D3D4;
}`, "",{"version":3,"sources":["webpack://./src/styles/global/Colors.scss","webpack://./src/styles/TranslationButton.scss","webpack://./src/styles/global/GlobalMixins.scss"],"names":[],"mappings":"AAAA;;;EAGI,sBAAA;ACCJ;;ADJA;;;EAGI,sBAAA;ACOJ;;AAPA;EACE,sBAAA;EACA,aAAA;EACA,yBAAA;EACA,iBAAA;AAUF;;AARA;EACE,sBAAA;EACA,aAAA;EACA,yBAAA;EACA,iBAAA;EACA,sBAAA;AAWF;AAVE;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;AAYJ;AAVE;EACE,kBAAA;EACA,YAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,yBAAA;AAYJ;;AARA;EC7BI,kBD8BoB;ECTpB,2CAAA;EDWF,uBAAA;EACA,YAAA;EACA,cDLW;ECMX,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,qBAAA;EACA,WAAA;AAWF;AAVE;EACE,mBDXY;ECYZ,YAAA;EACA,YAAA;EACA,gBAAA;AAYJ;AAVE;EACE,cD1BI;ACsCR","sourcesContent":["*,\n*::before,\n*::after {\n    box-sizing: border-box;\n}\n// Guardian Dashboard colors\n$lt-blue: #7DB7CC;\n$dk-blue: #19608f;\n\n$error: #CE3525;\n$error-dk: #aa3333;\n$error-hover: #cf4635;\n$hover-white: #E0E0E0;\n$light-background: #EFEFEF;\n\n$information: #00AEEF;\n$information-hover: #02BFFF;\n$text: #414042;\n$white: #EDEDED;\n$shadow: #525151;\n$red: #CB321A;\n$green: #4a8319;\n\n$important: #FEBF31;\n$grey0: #EDf0F1;\n$grey1: #D1D3D4;\n$grey2: #A7A9AC;\n$grey3: #808080;\n$grey3a: #707070;\n$grey4: #636161;\n$grey4a: #444343;\n$pale-blue: #C0DEF0;\n$pearl-blue: #0669B3;\n$pearl-blue-hover: #1786DB;\n$lt-pearl-blue: #63AEDE;\n$lt-pearl-blue-hover: #4589B3;\n$icon-blue: #4DD9FF;\n","@import \"../styles/global/Colors\";\n@import \"../styles/global/GlobalMixins\";\n\n.translation-buttons-container {\n  margin: -20px 45px 0 0;\n  display: flex;\n  justify-content: flex-end;\n  flex-wrap: nowrap;\n}\n.translation-buttons-container-main {\n  margin: -20px 45px 0 0;\n  display: flex;\n  justify-content: flex-end;\n  flex-wrap: nowrap;\n  flex-direction: column;\n  .button-container {\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-end;\n    margin-top: 5px;\n  }\n  .experimental-text {\n    position: relative;\n    bottom: -8px;\n    right: 5px;\n    display: flex;\n    flex-direction: row;\n    font-size: 0.7rem;\n    justify-content: flex-end;\n  }\n}\n\n.translation-button {\n  @include borderRadius(3px);\n  @include shadow();\n  background-color: white;\n  border: none;\n  color: $pearl-blue;\n  font-size: 0.7em;\n  font-weight: 600;\n  height: 22px;\n  margin-left: 10px;\n  transition: 0.1s ease;\n  width: 80px;\n  &:hover {\n    background: $lt-pearl-blue;\n    color: white;\n    color: black;\n    font-weight: 500;\n  }\n  &:active {\n    color: $grey1\n  }\n}\n","@import \"./Colors.scss\";\n\n@mixin borderRadius($radius: 5px) {\n    border-radius: $radius;\n}\n\n@mixin dialogueBold() {\n    font-weight: 600;\n    font-size: .9em;\n}\n\n@mixin input() {\n    border-radius: 5px;\n    font-weight: 400;\n    width: 100%;\n}\n\n@mixin infoRounded($radius) {\n    background: $information;\n    border-bottom-left-radius: $radius;\n    border-bottom-right-radius: $radius;\n}\n\n@mixin shadow() {\n    box-shadow: 0.1rem 0.15rem 0.3rem 0 $shadow;\n}\n@mixin shadowCustom($hor: 1px, $vert: 1px, $blur: 2px, $color: $shadow) {\n    box-shadow: $hor $vert $blur $color;\n}\n@mixin shadowBottom() {\n    box-shadow: 0 0.1rem 0.15rem 0 $shadow;\n}\n@mixin standardInputContainer() {\n    font-weight: 500;\n    font-size: .9rem;\n    margin: 10px 0;\n}\n@mixin standardInput() {\n    @include borderRadius(5px);\n    border: none;\n    border: 1px solid $grey3;\n    padding: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
